import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const api = axios.create({ baseURL: API, withCredentials: true });

// Only the backend auth gate sets X-Catalog-Auth; other 401s (e.g. wrong connect token) are not logouts.
api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401 && err.response.headers?.["x-catalog-auth"] === "required") {
      window.dispatchEvent(new Event("catalog-unauthorized"));
    }
    return Promise.reject(err);
  }
);

export const TYPE_ICON = {
  email_templates: "mail",
  text_templates: "message-square",
  action_plans: "list-checks",
  automations: "workflow",
  smart_lists: "filter",
  lead_flows: "route",
  tags: "tag",
  stages: "flag",
  custom_fields: "sliders-horizontal",
  groups: "users",
  teams: "users-round",
  users: "user",
  ponds: "waves",
  pipelines: "git-branch",
  lead_sources: "download",
};
